export { releasePageContext };
import { releasePageContextCommon } from './releasePageContextCommon';
import { assert } from './utils';
function releasePageContext(pageContext) {
    assert(pageContext.isHydration === true);
    assert(pageContext.isBackwardNavigation === null);
    return releasePageContextCommon(pageContext);
}
